import React from "react";
import { notify } from "@/shared/utils/notify";
import { ProductWarehouses } from "../../../../redux/@types";
import { productWarehousesService } from "../../../../shared/services";

export const useProductWarehouses = ({
  warehouseId,
  productId,
}: {
  warehouseId?: number;
  productId?: number;
}) => {
  const [loading, setLoagding] = React.useState<boolean>(false);
  const [productWarehouseInfo, setProductWarehouseInfo] = React.useState<
    ProductWarehouses[]
  >([]);

  const productWarehouses = async () => {
    if (loading) return;
    setLoagding(true);

    await productWarehousesService
      .find({warehouse_id: warehouseId})
      .then((res: any) => {
        setProductWarehouseInfo(res.data);
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoagding(false);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (warehouseId || productId) {
      productWarehouses();
    }
  }, [warehouseId, productId]);

  return {
    productWarehouseInfo,
    productWarehouses,
  };
};
